export const SEMANTIC_COLORS = ['neutral', 'primary', 'secondary', 'accent']

export const PALETTE_COLORS = [
  'gray', 'blue', 'indigo', 'purple', 'pink',
  'red', 'orange', 'yellow', 'lime', 'green', 'cyan'
]

function capitalize (s) {
  return s.charAt(0).toUpperCase() + s.slice(1)
}

export const ALL_HEADER_COLOR_OPTIONS = [
  ...SEMANTIC_COLORS.map(c => ({ value: c, label: capitalize(c) })),
  ...PALETTE_COLORS.map(c => ({ value: c, label: capitalize(c) })),
  { value: 'custom', label: 'Custom...' }
]

export const ALL_ZEBRA_COLOR_OPTIONS = [
  { value: 'none', label: 'None' },
  ...SEMANTIC_COLORS.filter(c => c !== 'neutral').map(c => ({ value: c, label: capitalize(c) })),
  { value: 'neutral', label: 'Neutral' },
  ...PALETTE_COLORS.map(c => ({ value: c, label: capitalize(c) })),
  { value: 'custom', label: 'Custom...' }
]

const SEMANTIC_SET = new Set(SEMANTIC_COLORS)

export function resolveHeaderTokenOverrides (colorKey, params) {
  if (!colorKey || SEMANTIC_SET.has(colorKey)) return null
  if (colorKey === 'custom') {
    const bg = params?.headerColorBg
    const text = params?.headerColorText
    if (!bg) return null
    return {
      '--tc-table-header-bg-color': bg,
      '--tc-table-header-color': text || '#FFFFFF',
      '--tc-table-header-divider-color': bg
    }
  }
  return {
    '--tc-table-header-bg-color': `var(--palette-${colorKey}-500)`,
    '--tc-table-header-color': `var(--palette-${colorKey}-050)`,
    '--tc-table-header-divider-color': `var(--palette-${colorKey}-900)`
  }
}

export function resolveZebraTokenOverrides (colorKey, params) {
  if (!colorKey || colorKey === 'none' || SEMANTIC_SET.has(colorKey)) return null
  if (colorKey === 'custom') {
    const bg = params?.zebraStripeBg
    if (!bg) return null
    return { '--tc-table-zebra-color': bg }
  }
  return {
    '--tc-table-zebra-color': `var(--palette-${colorKey}-100)`
  }
}
